import { Tag } from "gen/tag/models_pb"

import { data } from "./data"
import { TypedAccessor } from "./types"
import {
  extractTagColor,
  Tag as TagComponent,
} from "../../../../components/base/informational/Tag"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type TagAccessorFn<T> = TypedAccessor<T, Tag | undefined>
type TagColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width"> & {
  width?: TableCellWidth
}
export type TagColumnHelper<T> = (
  accessorFn: TagAccessorFn<T>,
  col: TagColumn<T>
) => DataColumn<T>

export function tag<T>(
  accessorFn: TagAccessorFn<T>,
  col: TagColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const tag = accessorFn(rowData)
      if (!tag) return null
      return <TagComponent name={tag.name} color={extractTagColor(tag.color)} />
    },
    width: TableCellWidth.ExtraExtraExtraLarge,
    ...col,
  })
}
